export default  (val) => {
  if (!val) return undefined;

  const getDefaultErr = () => {
    return {
      value: 'Не предвиденная ошибка',
      field: 'unknown'
    }
  }

  const getErr = (v) => {
    let temp = [];
    if (Array.isArray(v)) {
      v.map((e) => {
        temp = [...getErr(e)]
      })
    } else if (typeof v === 'object') {
      for(const [ key, value ] of Object.entries(v)) {
        if (value && typeof value === 'object') {
          temp.push(...getErr(value).map(e => e.field ? e : {field: key, value: e.value}))
        } else if (value) {
          temp.push({ field: key, value })
        }
      }
    } else {
      temp = [{ value: v }]
    }

    if (temp.length === 0) {
      temp.push(getDefaultErr());
    }
  
    return temp
  }
  return getErr(val)
}

export const getTextErrors = (errors) => {
  let textErrors = '';
  if (errors && errors.length) {
    errors.forEach(e => {
      const value = e?.value + '\n'|| ''
      textErrors += value
    });
  } else {
    textErrors = 'Незивестная ошибка'
  }
  return textErrors
}